import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP — see metadata.md GROUNDING NOTE.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "My recurring AI job pitched the SAME idea 7 of its last 8 runs — each under a fresh headline." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "Any job that runs on a schedule has a memory problem: every run is a blank slate." },
  { scene: "problem", fromSec: 6.2, holdSec: 6, caption: "So it re-discovers the same handful of ideas and re-ships them — and my inbox got 3 byte-identical digests." },
  { scene: "problem", fromSec: 12.5, holdSec: 5.5, caption: "The model isn't wrong. It just has no way to ask: have I said this already?" },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "So I gave it one: before it acts, compare the new output to what it already shipped." },
  { scene: "intuition", fromSec: 6.2, holdSec: 5, caption: "Too similar to past work? Reject it — and don't even pay the model to elaborate." },
];

export const GATE: ScriptLine[] = [
  { scene: "gate", fromSec: 0.4, holdSec: 6, caption: "A mission finishes. Before distilling it into a reusable recipe, a novelty gate runs first." },
  { scene: "gate", fromSec: 6.5, holdSec: 6, caption: "It scores the new objective against every recipe I've already saved." },
  { scene: "gate", fromSec: 12.8, holdSec: 5, caption: "Above the line, it's a duplicate — skip. Below it, it's new — keep going." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6, caption: "The score is word-token Jaccard — overlap of words, divided by their union. No embedding model." },
  { scene: "code", fromSec: 7, holdSec: 6.5, caption: "Threshold 0.3: cross 30% overlap with any saved recipe and it returns 'not_novel'." },
  { scene: "code", fromSec: 14, holdSec: 8, caption: "Honest version: it's cheap lexical overlap, not deep semantics. Plenty good as a pre-filter." },
];

export const REJECT: ScriptLine[] = [
  { scene: "reject", fromSec: 0.4, holdSec: 5.5, caption: "The win isn't just dedup — it's order. The check runs BEFORE the LLM call." },
  { scene: "reject", fromSec: 6.2, holdSec: 6.5, caption: "Not novel ⇒ no spend. The expensive model only writes the recipe once novelty passes." },
];

export const MEMORY: ScriptLine[] = [
  { scene: "memory", fromSec: 0.4, holdSec: 6, caption: "Layer two: every idea I actually send is logged in mission_sent_ideas — cross-run memory." },
  { scene: "memory", fromSec: 6.5, holdSec: 6, caption: "Next run, those titles are injected into the prompt: 'do NOT re-pitch these'." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 6, caption: "Three layers: a novelty gate, a sent-ideas memory, and a byte-identical resend guard." },
  { scene: "payoff", fromSec: 6.5, holdSec: 6, caption: "And a race fix: the slug is content-derived, so concurrent runs collapse to one via a unique index." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Recurring agents don't need to be smart to stop repeating themselves. They need a memory and a gate." },
  { scene: "outro", fromSec: 5.8, holdSec: 4, caption: "Next: a workflow that picks its own model — cheap when small, strong when big." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
